// import { useCallback } from 'react';
// import { useSiteContext } from './LayoutProvider';
import { Section } from "../components/Section";
import { ParallaxVideo } from "../components/Parallax-Video";
import React from "react";
import { Nav } from "../components/layout/Nav";
import { Footer } from "../components/layout/footer";
import { useLocation } from "@reach/router";
import { Contact } from "../components/layout/Contact";

export const ParallaxLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const location = useLocation();
  const isHome = location.pathname === "/";

  //   const { siteState, setSiteState } = useSiteContext();

  //   const toggleLanguage = useCallback(() => {
  //     setSiteState((s) => ({
  //       ...s,
  //       language: s.language === "en" ? "es" : "en",
  //     }));
  //   }, [setSiteState]);

  return (
    <main>
      <Nav />
      {isHome ? (<>
        <ParallaxVideo />
        {children}

        <Contact />
        <Footer /></>
      ) : (
        <>
          {children}
          <Contact />
          <Footer />
        </>
      )}
    </main>
  );
};
